import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::store
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:259
* @route '/motels/{motel}/profit-loss/categories'
*/
export const store = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/motels/{motel}/profit-loss/categories',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::store
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:259
* @route '/motels/{motel}/profit-loss/categories'
*/
store.url = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { motel: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: typeof args.motel === 'object'
        ? args.motel.id
        : args.motel,
    }

    return store.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::store
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:259
* @route '/motels/{motel}/profit-loss/categories'
*/
store.post = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::store
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:259
* @route '/motels/{motel}/profit-loss/categories'
*/
const storeForm = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::store
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:259
* @route '/motels/{motel}/profit-loss/categories'
*/
storeForm.post = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::update
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:279
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
export const update = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/motels/{motel}/profit-loss/categories/{category}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::update
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:279
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
update.url = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            motel: args[0],
            category: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: typeof args.motel === 'object'
        ? args.motel.id
        : args.motel,
        category: typeof args.category === 'object'
        ? args.category.id
        : args.category,
    }

    return update.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace('{category}', parsedArgs.category.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::update
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:279
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
update.put = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::update
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:279
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
const updateForm = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::update
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:279
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
updateForm.put = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::destroy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:292
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
export const destroy = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/motels/{motel}/profit-loss/categories/{category}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::destroy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:292
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
destroy.url = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            motel: args[0],
            category: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: typeof args.motel === 'object'
        ? args.motel.id
        : args.motel,
        category: typeof args.category === 'object'
        ? args.category.id
        : args.category,
    }

    return destroy.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace('{category}', parsedArgs.category.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::destroy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:292
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
destroy.delete = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::destroy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:292
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
const destroyForm = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::destroy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:292
* @route '/motels/{motel}/profit-loss/categories/{category}'
*/
destroyForm.delete = (args: { motel: string | { id: string }, category: string | { id: string } } | [motel: string | { id: string }, category: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const categories = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default categories